import { useParams } from "@tanstack/react-router";
import { Card, PageHeader } from "@/components/primitives";

export function JourneyDetailPage() {
  const { journeyId } = useParams({ from: "/journeys/$journeyId" });
  const saved = JSON.parse(
    window.localStorage.getItem("cosmos:journeys") ?? "[]"
  ) as Array<{ id: string; title: string; summary: string }>;
  const journey = saved.find((entry) => entry.id === journeyId);

  return (
    <div className="page">
      <PageHeader
        eyebrow="Journey draft"
        title={journey?.title ?? journeyId}
        subtitle={journey?.summary ?? "Open the linked action request for approval details."}
      />
      <Card>
        <p>
          Journey details are stored as a guarded Cosmos action. Review and approve
          the write request in the Actions area.
        </p>
      </Card>
    </div>
  );
}
